import { date } from 'quasar'
import wordingModules from 'src/store/modules/wording'
import generalModules from 'src/store/general'
import { commonDate, digitGroup, daysBetween, dateTime } from 'src/helpers'
import getEnv from 'src/getEnv'

const { lang, paymentTerms } = generalModules.state()
const wording = wordingModules.state
const { uploadStatus, confirmPaymentStatus } = wording[lang]

const paymentType = (type) => {
  return (
    {
      TUNAI: 'Tunai',
      JM_PAYLATER: 'JM Paylater',
      PAPER_PAYLATER: 'Paper',
      VIRTUAL_ACCOUNT: 'Virtual Account',
      TEMPO: 'Termin',
      null: '-',
      undefined: '-',
      '': '-'
    }[type] || type
  )
}

const tables = {
  doReturnLetter: {
    visibleColumns: [
      'po_no',
      'do_no',
      'supplier_name',
      'payment_term',
      'due_date',
      'delivery_at',
      'sending_at',
      'receipt',
      'status'
    ],

    columns: [
      {
        name: 'do_no',
        label: 'No. Delivery Order',
        align: 'left',
        field: (row) => {
          return `
            <a href="/do/detail/${row.id}/${encodeURIComponent(
            row.do_no
          )}" class="goto-preview-page">
              <strong class="text-primary">${row.do_no}</strong>
            </a>
          `
        },
        sortable: true
      },
      {
        name: 'po_no',
        label: 'No. Purchase Order',
        align: 'left',
        field: (row) => {
          return `
            <a href="/po/detail/${row.po_id}/${encodeURIComponent(
            row.po_no
          )}" class="goto-preview-page">
              <strong class="text-primary">${row.po_no}</strong>
            </a>
            <div class="text-grey-6" style="font-size: 12px">
              ${row.supplier_name ? row.supplier_name : '-'}
            </div>
          `
        },
        sortable: true
      },
      {
        name: 'so_no',
        label: 'No. Sales Order',
        align: 'left',
        field: (row) => {
          return `
            <a href="/so/detail/${row.so_id}/${encodeURIComponent(
            row.so_no
          )}" class="goto-preview-page">
              <strong class="text-primary">${row.so_no}</strong>
            </a>
            <div class="text-grey-6" style="font-size: 12px">
              ${row.no_order ? row.no_order : '-'}
            </div>
          `
        },
        sortable: true
      },

      {
        name: 'no_order',
        label: 'No. Order',
        align: 'left',
        field: (row) => {
          return row.no_order ? `<strong>${row.no_order}</strong>` : '-'
        },
        sortable: true,
        rowClass: 'td-width-small text-primary'
      },

      {
        name: 'customer',
        field: 'customer_name',
        label: 'Customer',
        align: 'left',
        rowClass: 'td-width-small'
      },
      {
        name: 'supplier_name',
        field: 'supplier_name',
        label: 'Vendor',
        align: 'left',
        rowClass: 'td-width-small'
      },

      {
        name: 'delivery_at',
        field: 'delivery_at',
        label: 'Tanggal Produk Diterima',
        align: 'left',
        commonDate: true
      },
      {
        name: 'return_letter_at',
        field: 'return_letter_at',
        label: 'Tanggal Unggah SJ Balik',
        align: 'left',
        commonDate: true
      },

      {
        name: 'total_price',
        field: 'total_price',
        label: 'Total Tagihan',
        align: 'left',
        inRupiah: true
      },
      {
        name: 'total_price_exc_ppn',
        field: 'total_price_exc_ppn',
        label: `Total Tagihan Exc PPN ${getEnv('VAT_PERCENTAGE')}`,
        align: 'left',
        inRupiah: true
      },

      {
        name: 'receipt',
        label: 'Invoice',
        align: 'left',
        field: (row) => {
          const status = !row.do_file.receipt ? 'NOT_UPLOADED' : 'UPLOADED'
          const { label, badgeClass } = uploadStatus[status]
          return label !== undefined
            ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
            : null
        }
      },
      {
        name: 'invoice',
        label: 'Tanda Terima',
        align: 'left',
        field: (row) => {
          const status = !row.do_file.invoice ? 'NOT_UPLOADED' : 'UPLOADED'
          const { label, badgeClass } = uploadStatus[status]
          return label !== undefined
            ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
            : null
        }
      },
      {
        name: 'tax',
        label: 'Faktur Pajak',
        align: 'left',
        field: (row) => {
          const status = !row.do_file.tax_invoice ? 'NOT_UPLOADED' : 'UPLOADED'
          const { label, badgeClass } = uploadStatus[status]
          return label !== undefined
            ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
            : null
        }
      },
      {
        name: 'status',
        label: 'DO Tanda Tangan',
        align: 'left',
        field: (row) => {
          const status = !row.do_file.do_sign_sales
            ? 'NOT_UPLOADED'
            : 'UPLOADED'
          const { label, badgeClass } = uploadStatus[status]
          return label !== undefined
            ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
            : null
        }
      },
      {
        name: 'qty_update',
        label: 'Perubahan Kuantitas',
        field: (row) => {
          return row.qty_update
            ? '<span class="text-negative">Ada</span>'
            : '<span class="text-primary">Tidak Ada</span>'
        },
        align: 'center',
        rowClass: 'text-center'
      }
    ],

    tabs: {
      sent: [
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            const img = require('src/assets/images/icons/16x16-global.svg')
            return `
              <div class="column gap-1">
                <div class="row items-center gap-2">
                  <a href="/do/detail/${row.id}/${encodeURIComponent(
                  row.do_no
                )}" class="goto-preview-page">
                    <strong class="text-primary">${row.do_no} </strong>
                  </a>
                  ${
                    row?.is_customer_digital_invoice
                    ? `<img
                        src="${img}"
                        alt="warning icon"
                      >`
                    : ''
                  }
                </div>
                  ${
                    row?.is_customer_digital_invoice
                  ? `
                  <div role="alert" class="custom-badge-square custom-badge-blue" style="width:fit-content">
                    Digital Invoice
                  </div>`
                  : ''
                }
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'po_no',
          label: 'No. Purchase Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/po/detail/${row.po_id}/${encodeURIComponent(
              row.po_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.po_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.supplier_name ? row.supplier_name : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/so/detail/${row.so_id}/${encodeURIComponent(
              row.so_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.so_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.no_order ? row.no_order : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'customer',
          field: 'customer_name',
          label: 'Customer',
          align: 'left',
          rowClass: 'td-width-small'
        },

        {
          name: 'received_at',
          field: 'received_at',
          label: 'Tgl. Barang Tiba',
          align: 'left',
          commonDate: true
        }
      ],
      returnLetter: [
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            const img = require('src/assets/images/icons/16x16-global.svg')

            return `
              <div class="column gap-1">
                <div class="row items-center gap-2">
                  <a href="/do/detail/${row.id}/${encodeURIComponent(
                  row.do_no
                )}" class="goto-preview-page">
                    <strong class="text-primary">${row.do_no} </strong>
                  </a>
                  ${
                    row?.is_customer_digital_invoice
                    ? `<img
                        src="${img}"
                        alt="warning icon"
                      >`
                    : ''
                  }
                </div>
                  ${
                    row?.is_customer_digital_invoice
                  ? `
                  <div role="alert" class="custom-badge-square custom-badge-blue" style="width:fit-content">
                    Digital Invoice
                  </div>`
                  : ''
                }
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'po_no',
          label: 'No. Purchase Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/po/detail/${row.po_id}/${encodeURIComponent(
              row.po_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.po_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.supplier_name ? row.supplier_name : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/so/detail/${row.so_id}/${encodeURIComponent(
              row.so_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.so_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.no_order ? row.no_order : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'customer',
          field: 'customer_name',
          label: 'Customer',
          align: 'left',
          rowClass: 'td-width-small'
        },

        {
          name: 'received_at',
          field: 'received_at',
          label: 'Tgl. Barang Tiba',
          align: 'left',
          commonDate: true
        },

        {
          name: 'return_letter_at',
          field: 'return_letter_at',
          label: 'Tgl. SJ Balik',
          align: 'left',
          commonDate: true
        }
      ],
      finished: [
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            return `
            <div class="column gap-1">
              <a href="/do/detail/${row.id}/${encodeURIComponent(
              row.do_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.do_no}</strong>
              </a>
                ${
                  row?.is_digital_invoice
                ? `
                <div role="alert" class="custom-badge-square custom-badge-blue" style="width:fit-content">
                  Digital Invoice
                </div>`
                : ''
              }
            </div>
            `
          },
          sortable: true
        },

        {
          name: 'po_no',
          label: 'No. Purchase Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/po/detail/${row.po_id}/${encodeURIComponent(
              row.po_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.po_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.supplier_name ? row.supplier_name : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/so/detail/${row.so_id}/${encodeURIComponent(
              row.so_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.so_no}</strong>
              </a>
              <div class="text-grey-6" style="font-size: 12px">
                ${row.no_order ? row.no_order : '-'}
              </div>
            `
          },
          sortable: true
        },

        {
          name: 'customer',
          field: 'customer_name',
          label: 'Customer',
          align: 'left',
          rowClass: 'td-width-small'
        },

        {
          name: 'received_at',
          field: 'received_at',
          label: 'Tgl. Barang Tiba',
          align: 'left',
          commonDate: true
        },

        {
          name: 'return_letter_at',
          field: 'return_letter_at',
          label: 'Tgl. SJ Balik',
          align: 'left',
          commonDate: true
        },

        {
          name: 'finished_at',
          field: 'finished_at',
          label: 'Tgl. Tukar Faktur',
          align: 'left',
          commonDate: true
        }
      ]
    }
  },

  taxInvoice: {
    parent: {
      visibleColumns: [
        'so_no_full',
        'customer_name',
        'payment_type',
        'created_at',
        'total_price_all',
        'tax_invoice_bill_status'
      ],

      columns: [
        {
          name: 'so_no_full',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/so/detail/${row.id}/${encodeURIComponent(
              row.so_no_full
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.so_no_full}</strong>
              </a>
            `
          },
          sortable: true
        },
        {
          name: 'customer_name',
          field: 'customer_name',
          label: 'Pembeli',
          align: 'left',
          format: (val) =>
            val ? `<div class="text-capitalize">${val}</div>` : '-'
        },
        {
          name: 'payment_type',
          field: 'payment_type',
          label: 'Ketentuan Pembayaran',
          align: 'left',
          format: (val) => {
            const term = paymentTerms.find((p) => p.value === val)
            return term.label
          }
        },
        {
          name: 'created_at',
          field: 'created_at',
          label: 'Tanggal Order',
          align: 'left',
          commonDate: true
        },
        {
          name: 'total_price_all',
          field: 'total_price_all',
          label: 'Total Pembelian',
          align: 'left',
          format: (val) => (val ? `Rp${digitGroup(val)}` : '-')
        },
        {
          name: 'tax_invoice_bill_status',
          field: 'tax_invoice_bill_status',
          label: 'Status',
          align: 'center',
          rowClass: 'text-center',
          format: (val) => {
            const { label, badgeClass } = uploadStatus[val]
            return val && label !== undefined
              ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
              : null
          }
        }
      ]
    },

    child: {
      columns: [
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/do/detail/${row.id}/${encodeURIComponent(
              row.do_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.do_no}</strong>
              </a>
            `
          }
        },
        {
          name: 'sending_at',
          field: 'sending_at',
          label: 'Tanggal Terkirim',
          align: 'left',
          commonDate: true
        },
        {
          name: 'return_letter_at',
          field: 'return_letter_at',
          label: 'Tanggal Surat Jalan Balik',
          align: 'left',
          commonDate: true
        },
        {
          name: 'total_price',
          field: 'total_price',
          label: 'Total Pembelian',
          align: 'left',
          format: (val) => (val ? `Rp${digitGroup(val)}` : '-')
        },
        {
          name: 'tax_invoice_bill_status',
          field: 'tax_invoice_bill_status',
          label: 'Status',
          align: 'center',
          rowClass: 'text-center',
          format: (val) => {
            const { label, badgeClass } = uploadStatus[val]
            return val && label !== undefined
              ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
              : null
          }
        }
      ]
    }
  },

  confirmPayment: {
    parent: {
      visibleColumns: [
        'so_no',
        'customer_name',
        'payment_type',
        'created_at',
        'total_price_all',
        'verif_status'
      ],

      columns: [
        {
          name: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/so/detail/${row.id}/${encodeURIComponent(
              row.so_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.so_no}</strong>
              </a>
            `
          },
          sortable: true
        },
        {
          name: 'customer_name',
          field: 'customer_name',
          label: 'Pembeli',
          align: 'left',
          format: (val) =>
            val ? `<div class="text-capitalize">${val}</div>` : '-'
        },
        {
          name: 'payment_type',
          field: 'payment_type',
          label: 'Ketentuan Pembayaran',
          align: 'left',
          format: (val) => {
            const term = val === 'TERMIN' ? 'Termin' : 'Tunai'
            return term
          }
        },
        {
          name: 'created_at',
          field: 'created_at',
          label: 'Tanggal Order',
          align: 'left',
          commonDate: true
        },
        {
          name: 'total_price_all',
          field: 'total_price_all',
          label: 'Total Pembelian',
          align: 'left',
          format: (val) => (val ? `Rp${digitGroup(val)}` : '-')
        },
        {
          name: 'verif_status',
          field: 'verif_status',
          label: 'Status',
          align: 'center',
          rowClass: 'text-center',
          format: (val) => {
            const { label, badgeClass } = confirmPaymentStatus[val]
            return val && label !== undefined
              ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
              : null
          }
        }
      ]
    },

    child: {
      columns: [
        {
          name: 'po_no',
          label: 'No. Purchase Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/po/detail/${row.po_id}/${encodeURIComponent(
              row.po_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.po_no}</strong>
              </a>
            `
          }
        },
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            return `
              <a href="/do/detail/${row.do_id}/${encodeURIComponent(
              row.do_no
            )}" class="goto-preview-page">
                <strong class="text-primary">${row.do_no}</strong>
              </a>
            `
          }
        },
        {
          name: 'order_date',
          field: 'order_date',
          label: 'Tanggal Order',
          align: 'left',
          commonDate: true
        },
        {
          name: 'payment_date',
          field: 'payment_date',
          label: 'Tanggal Pembayaran',
          align: 'left',
          commonDate: true
        },
        {
          name: 'verif_status',
          field: 'verif_status',
          label: 'Status',
          align: 'center',
          rowClass: 'text-center',
          format: (val) => {
            const { label, badgeClass } = confirmPaymentStatus[val]
            return val && label !== undefined
              ? `<div role="alert" class="custom-badge ${badgeClass}">${label}</div>`
              : null
          }
        }
      ]
    }
  },

  invoiceList: {
    tabs: {

      nonConfirm: [
        {
          name: 'invoice_no',
          field: (row) => {
            const imgSend = `
            <div class="custom-badge-blue q-my-xs">
                <img
                  src="${require('src/assets/images/icons/send-2.svg')}"
                  alt="icon"
                >
              </div>`

            if (!row.invoice_no) {
              return '-'
            }

            const link = `<a href="/invoice/detail/${row.id}/${encodeURIComponent(
              row.invoice_no
            )}" class="goto-preview-page"><strong>${
              row.invoice_no
            }</strong></a>`

            const status = row.draft && !!row.draft
              ? '<br/> <div class="custom-badge-purple text-caption q-my-xs">Draf</div>'
              : '<br/>' + imgSend

            return `${link}${status}`
          },
          label: 'No. Invoice',
          align: 'left',
          sortable: true,
          rowClass: 'text-primary text-weight-bold'
        },
        {
          name: 'so_no',
          field: (row) => {
            return row.so_no
              ? ` <a href="/so/detail/${row.so_id}/${encodeURIComponent(
                  row.so_no
                )}" class="goto-preview-page">
              <strong class="text-primary">${row.so_no}</strong>
            </a>
            <div class="text-caption text-grey">${row.so_no_cust || '-'}</div>`
              : '-'
          },
          label: 'No. Sales Order',
          align: 'left',
          sortable: true,
          rowClass: 'text-no-wrap'
        },
        {
          name: 'customer',
          field: (row) => {
            return row.customer_name
              ? `${row.customer_name}
                <div class="text-caption text-grey">
                ${
                  {
                    PROJECT_OWNER: 'Pemilik Proyek',
                    ARCHITECT: 'Arsitek',
                    DEVELOPER: 'Developer',
                    CONTRACTOR: 'Kontraktor',
                    OTHER: 'Lainnya'
                  }[row?.customer_type] || '-'
                }
                </div>`
              : '-'
          },
          label: 'Customer',
          align: 'left',
          sortable: true,
          rowClass: 'td-width-sm'
        },
        {
          name: 'created_at',
          field: 'created_at',
          label: 'Tanggal Diajukan',
          align: 'left',
          sortable: true,
          commonDate: true
        },
        {
          name: 'payment_type',
          field: (row) => paymentType(row.payment_type),
          label: 'Pembayaran',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_price',
          field: (row) => `Rp ${digitGroup(row.total_price)}`,
          label: 'Nilai Tagihan',
          align: 'right',
          rowClass: 'text-right text-no-wrap',
          sortable: true
        },
        {
          name: 'document',
          field: (row) => {
            return `
            ${
              row.sign && !!row.sign
                ? '<div class="custom-badge-green">TTD</div>'
                : ''
            }

             ${
               row.stamp && !!row.stamp
                 ? '<div class="custom-badge-blue q-my-xs">Materai</div>'
                 : ''
             }

              ${
                row.tax_invoice && !!row.tax_invoice
                  ? '<div class="custom-badge-yellow">FP</div>'
                  : ''
              }
            `
          },
          label: 'Kelengkapan',
          align: 'left',
          sortable: true
        }
      ],

      confirmed: [
        {
          name: 'invoice_no',
          field: (row) => {
            return row.invoice_no || '-'
          },
          label: 'No. Invoicse',
          align: 'left',
          sortable: true,
          rowClass: 'text-primary text-weight-bold'
        },
        {
          name: 'so_no',
          field: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          sortable: true,
          rowClass: 'text-no-wrap'
        },
        {
          name: 'customer',
          field: 'customer',
          label: 'Customer',
          align: 'left',
          sortable: true,
          rowClass: 'td-width-sm'
        },
        {
          name: 'payment_type',
          field: (row) => paymentType(row.payment_type),
          label: 'Pembayaran',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_price',
          field: (row) => `Rp${digitGroup(row.total_price)}`,
          label: 'Total Tagihan',
          align: 'left',
          sortable: true
        },
        {
          name: 'created_at',
          field: 'created_at',
          label: 'Tanggal Konfirmasi',
          align: 'left',
          sortable: true,
          commonDate: true
        },
        {
          name: 'list_do_no',
          field: (row) => {
            if (!row.list_do_no) {
              return '-'
            }
            if (row.list_do_no.length <= 1) {
              return `<div>${row.list_do_no[0]}</div>`
            }
            return `<div>${row.list_do_no[0]}</div>
                    <div class="custom-toggle">
                      <label>
                        <input type="checkbox"/>
                        <div class="custom-toggle--text">
                          <small class="text-primary text-bold">
                            + ${row.list_do_no.length - 1} Lainnya
                          </small>
                        </div>

                        <div class="custom-toggle--content">
                          ${row.list_do_no
                            .filter((_item, index) => index !== 0)
                            .map(
                              (item) =>
                                `<div class="text-caption">${item}</div>`
                            )
                            .join('')}
                        </div>
                      </label>
                    </div>`
          },
          label: 'Dibuat Dari',
          align: 'left',
          sortable: true
        },
        {
          name: 'tax_invoice',
          field: (row) => {
            return (
              {
                'Belum Ada': '<div class="custom-badge-red">Belum Ada</div>',
                'Sudah Ada': '<div class="custom-badge-green">Sudah Ada</div>'
              }[row.tax_invoice] || '-'
            )
          },
          label: 'Faktur Pajak',
          align: 'left',
          sortable: true
        }
      ],

      rejected: [
        {
          name: 'invoice_no',
          field: 'invoice_no',
          label: 'No. Invoice',
          align: 'left',
          sortable: true,
          rowClass: 'text-primary text-weight-bold'
        },
        {
          name: 'so_no',
          field: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          sortable: true
        },
        {
          name: 'customer',
          field: 'customer',
          label: 'Customer',
          align: 'left',
          sortable: true
        },
        {
          name: 'payment_type',
          field: (row) => paymentType(row.payment_type),
          label: 'Pembayaran',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_price',
          field: (row) => `Rp${digitGroup(row.total_price)}`,
          label: 'Total Tagihan',
          align: 'left',
          sortable: true
        },
        {
          name: 'list_do_no',
          field: (row) => {
            if (!row.list_do_no) {
              return '-'
            }

            if (row.list_do_no.length === 1) {
              return `<div>${row.list_do_no[0]}</div>`
            }

            return `<div>${row.list_do_no[0]}</div>
                    <div class="custom-toggle">
                      <label>
                        <input type="checkbox"/>
                        <div class="custom-toggle--text">
                          <small class="text-primary text-bold">
                            + ${row.list_do_no.length - 1} Lainnya
                          </small>
                        </div>

                        <div class="custom-toggle--content">
                          ${row.list_do_no
                            .filter((_item, index) => index !== 0)
                            .map(
                              (item) =>
                                `<div class="text-caption">${item}</div>`
                            )
                            .join('')}
                        </div>
                      </label>
                    </div>`
          },
          label: 'Dibuat Dari',
          align: 'left',
          sortable: true
        },
        {
          name: 'rejected_at',
          field: 'rejected_at',
          label: 'Tanggal Ditolak',
          align: 'left',
          sortable: true,
          commonDate: true
        },
        {
          name: 'cancel_note',
          field: 'cancel_note',
          label: 'Alasan Penolakan',
          align: 'left',
          sortable: true
        }
      ],

      payment: [
        {
          name: 'invoice_no',
          field: (row) => {
            const imgSend = `
            <div class="custom-badge-blue q-my-xs">
                <img
                  src="${require('src/assets/images/icons/send-2.svg')}"
                  alt="icon"
                >
              </div>`

            let statusBadge = ''
            if (row.draft && !!row.draft) {
              statusBadge = '<br/> <div class="custom-badge-purple text-caption q-my-xs">Draf</div>'
            } else {
              statusBadge = '<br/>' + imgSend
            }

            return row.invoice_no
              ? ` <a href="/invoice/detail/${row.id}/${encodeURIComponent(
                  row.invoice_no
                )}" class="goto-preview-page"><strong>${
                  row.invoice_no
                }</strong></a>
              ${statusBadge}
              `
              : '-'
          },
          label: 'No. Invoice',
          align: 'left',
          sortable: true,
          rowClass: 'text-primary text-weight-bold'
        },
        {
          name: 'so_no',
          field: (row) => {
            return row.so_no
              ? ` <a href="/so/detail/${row.so_id}/${encodeURIComponent(
                  row.so_no
                )}" class="goto-preview-page">
              <strong class="text-primary">${row.so_no}</strong>
            </a>
            <div class="text-caption text-grey">${row.so_no_cust || '-'}</div>`
              : '-'
          },
          label: 'No. Sales Order',
          align: 'left',
          sortable: true
        },
        {
          name: 'customer',
          field: (row) => {
            return row.customer_name
              ? `${row.customer_name}
                <div class="text-caption text-grey">
                ${
                  {
                    PROJECT_OWNER: 'Pemilik Proyek',
                    ARCHITECT: 'Arsitek',
                    DEVELOPER: 'Developer',
                    CONTRACTOR: 'Kontraktor',
                    OTHER: 'Lainnya'
                  }[row?.customer_type] || '-'
                }
                </div>`
              : '-'
          },
          label: 'Customer',
          align: 'left',
          sortable: true
        },
        {
          name: 'payment_type',
          field: (row) => paymentType(row.payment_type),
          label: 'Pembayaran',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_price',
          field: (row) => `Rp ${digitGroup(row.total_price)}`,
          label: 'Nilai Tagihan',
          align: 'right',
          rowClass: 'text-right text-no-wrap',
          sortable: true
        },
        {
          name: 'due_date',
          field: (row) => {
            if (!row.due_date) return '-'

            const timeLeft = daysBetween(new Date(), new Date(row.due_date))
            let timeLeftText = ''
            if (timeLeft === 0) {
              timeLeftText = '1 Hari'
            } else if (timeLeft > 0) {
              timeLeftText = timeLeft + ' Hari Lagi'
            } else {
              timeLeftText = timeLeft + ' Hari'
            }
            return (
              `
              <div class="text-no-wrap">
                ${commonDate({
                  date: row.due_date,
                  useDayName: true
                })}
              </div>
            ` +
              (row.due_date &&
              ['UNPAID', 'UNVERIFIED', 'REJECTED'].includes(row.verify_status)
                ? `<div class="text-caption text-negative">
                    ${timeLeftText}
                  </div>`
                : '')
            )
          },
          label: 'Jatuh Tempo',
          align: 'left',
          sortable: true
        },
        {
          name: 'verified_at',
          field: 'verified_at',
          label: 'Tgl. Diverifikasi',
          align: 'left',
          sortable: true,
          commonDate: true
        },
        {
          name: 'document',
          field: (row) => {
            return `
            ${
              row.sign && !!row.sign
                ? '<div class="custom-badge-green">TTD</div>'
                : ''
            }

             ${
               row.stamp && !!row.stamp
                 ? '<div class="custom-badge-blue q-my-xs">Materai</div>'
                 : ''
             }

              ${
                row.tax_invoice && !!row.tax_invoice
                  ? '<div class="custom-badge-yellow">FP</div>'
                  : ''
              }
            `
          },
          label: 'Kelengkapan',
          align: 'left',
          sortable: true
        },
        {
          name: 'verify_status',
          field: (row) => {
            return (
              {
                VERIFIED: '<div class="custom-badge-green">Dikonfirmasi</div>',
                VERIVIED_AUTOMATIC:
                  '<div class="custom-badge-green">Dikonfirmasi Otomatis</div>',
                UNPAID: '<div class="custom-badge-purple">Belum Dibayar</div>',
                PAID: '<div class="custom-badge-yellow">Sudah Dibayar</div>',
                UNVERIFIED:
                  '<div class="custom-badge-blue">Belum Dikonfirmasi</div>',
                REJECTED: '<div class="custom-badge-red">Pembayaran Ulang</div>'
              }[row.verify_status] || '-'
            )
          },
          label: 'Status',
          align: 'center',
          sortable: true,
          rowClass: 'text-center'
        }
      ],

      disbursement: [
        {
          name: 'invoice_no',
          field: (row) => {
            return row.invoice_no
              ? ` <a href="/invoice/detail/${row.id}/${encodeURIComponent(
                  row.invoice_no
                )}" class="goto-preview-page"><strong>${
                  row.invoice_no
                }</strong></a> <br/> <div> ${row.ref_id || '-'} </div>`
              : '-'
          },
          label: 'No. Invoice',
          align: 'left',
          sortable: true,
          rowClass: 'text-primary text-weight-bold'
        },
        {
          name: 'company_name',
          field: (row) => {
            return `<div>${row.company_name || '-'}</div>`
          },
          label: 'Customer',
          align: 'left',
          sortable: true,
          rowClass: 'td-width-medium text-primary text-weight-bold'
        },
        {
          name: 'bnpl_partner',
          field: (row) => {
            const paymentType =
              {
                'MODAL RAKYAT': 'Modal Rakyat',
                'JM TEMPO': 'JM Tempo',
                'JM PAYLATER': 'JM Paylater',
                PAPER: 'Paper.id',
                KOINWORKS: 'Koinworks',
                CREDILINQ: 'Credilinq.ai'
              }[row.bnpl_name] || 'Tunai'

            const image = row.bnpl_name
              ? row.image_bnpl
              : require('src/assets/images/icons/24x24-tunai-circle.png')

            return `<div class="flex no-wrap items-center gap-2">
              <img
                src="${image}"
                alt="${row.bnpl_name}"
                class="payment-type-img"
              >
              <div class="flex column text-no-wrap">
                <strong>${paymentType}</strong>
                <span class="text-grey-7">
                  ${
                    row.bnpl_name ? row.termin_day + ' Hari' : 'Transfer Manual'
                  }
                </span>
              </div>
            </div>`
          },
          label: 'BNPL Partner',
          align: 'left',
          sortable: true,
          rowClass: 'td-width-small'
        },
        {
          name: 'payment_status',
          field: (row) => {
            return `<div class="text-capitalize disbursement__table-status-payment custom-badge-${
              {
                SUCCESS: 'green',
                PENDING: 'yellow',
                EXPIRED: 'red',
                FAILED: 'red'
              }[row.payment_status] || 'green'
            }
            dense">
              ${row.payment_status.toLowerCase() || '-'}
            </div>
            <div class='disbursement__table-status-loan'>${
              row.loan_status_initcap || '-'
            }</div>`
          },
          label: 'Status',
          align: 'left',
          sortable: true,
          rowClass: 'td-width-medium'
        },
        {
          name: 'createdAt',
          field: 'created_at',
          label: 'Tgl. Invoice Dibuat',
          commonDate: true,
          align: 'left',
          rowClass: 'text-bold td-width-small'
        },
        {
          name: 'confirmedByCustomerAt',
          field: 'confirmed_by_customer_at',
          label: 'Tgl. Diverifikasi',
          commonDate: true,
          align: 'left',
          rowClass: 'text-bold td-width-small'
        },
        {
          name: 'loanCreatedAt',
          field: 'loan_created_at',
          label: 'Tgl. Pinjaman Dibuat',
          commonDate: true,
          align: 'left',
          rowClass: 'text-bold td-width-small'
        },
        {
          name: 'dueDate',
          field: (row) => {
            return `<div class='text-bold text-negative'>${
              row.due_date
                ? commonDate({
                    date: row.due_date,
                    useDayName: true
                  })
                : '-'
            }</div>`
          },
          label: 'Tgl. Jatuh Tempo',
          align: 'left',
          rowClass: 'td-width-small'
        },
        {
          name: 'paidAt',
          field: 'paid_at',
          label: 'Tgl. Pelunasan',
          commonDate: true,
          align: 'left',
          rowClass: 'text-bold td-width-small'
        },
        {
          name: 'total_price',
          field: (row) => {
            return row.total_price ? `Rp ${digitGroup(row.total_price)}` : '-'
          },
          label: 'Nilai Invoice',
          align: 'left',
          sortable: true,
          classes: 'text-no-wrap',
          rowClass: 'td-width-medium'
        },
        {
          name: 'total_disbursement',
          field: (row) => {
            return row.total_disbursement
              ? `Rp ${digitGroup(row.total_disbursement)}`
              : '-'
          },
          label: 'Nilai Disbursement',
          align: 'left',
          sortable: true,
          classes: 'text-no-wrap',
          rowClass: 'td-width-medium'
        }
      ],

      exchangeInvoice: [
        {
          name: 'invoice_no',
          field: (row) => {
            let totalOtherInvoice = ''

            if (row.invoice.length > 1) {
              totalOtherInvoice = `+${row.invoice.length - 1} Lainnya`
            }

            return row.invoice[0]?.id
              ? ` <div>
                      ${row.invoice?.[0]?.invoice_no || '-'}
                  </div>
                  <div class="text-grey-6"> ${totalOtherInvoice} </div>`
              : '-'
          },
          label: 'Invoice',
          align: 'left',
          sortable: true,
          rowClass: ''
        },
        {
          name: 'total_price',
          field: (row) => {
            return row.total_price ? `Rp ${digitGroup(row.total_price)}` : '-'
          },
          label: 'Nilai Tagihan',
          align: 'right',
          sortable: true,
          classes: 'text-no-wrap',
          rowClass: 'td-width-medium text-right'
        },
        {
          name: 'uploaded_at',
          field: (row) => {
            return `<div class=''>${
              row.uploaded_at
                ? `<div>
                    ${date.formatDate(row.uploaded_at, 'dddd, MMM D YYYY')}
                  </div>
                  <div class="small">
                    ${date.formatDate(row.uploaded_at, 'HH:mm')}
                  </div>`
                : '-'
            }</div>`
          },
          label: 'Tgl. Unggah',
          align: 'left',
          rowClass: 'td-width-small'
        }
      ],

      createExchangeInvoice: [
        {
          name: 'invoice_no',
          field: (row) => {
            return row.invoice_no
              ? `<div> ${row.invoice_no || '-'} </div>`
              : '-'
          },
          label: 'No. Invoice',
          align: 'left',
          sortable: true,
          rowClass: ''
        },
        {
          name: 'total_price',
          field: (row) => {
            return row.total_price ? `Rp ${digitGroup(row.total_price)}` : '-'
          },
          label: 'Nominal',
          align: 'right',
          sortable: true,
          classes: 'text-no-wrap',
          rowClass: 'text-right text-no-wrap'
        }
      ],

      massFakturPajak: [
        {
          name: 'invoice_no',
          field: (row) => {
            return row.invoice_no
              ? `<div> ${row.invoice_no || '-'} </div>`
              : '-'
          },
          label: 'Invoice',
          align: 'left',
          sortable: true,
          rowClass: ''
        },
        {
          name: 'tax_invoice_number',
          field: (row) => {
            return row.tax_invoice_number
              ? `<div> ${row.tax_invoice_number || '-'} </div>`
              : '-'
          },
          label: 'No. Faktur Pajak',
          align: 'left',
          sortable: true,
          rowClass: ''
        }
      ]
    }
  },

  invoiceDetail: {
    columns: [
      {
        name: 'inv_no',
        field: 'inv_no',
        label: 'No. Invoice',
        align: 'left',
        sortable: true,
        classes: 'text-no-wrap text-bold'
      },
      {
        name: 'price_total',
        field: (row) => {
          return row.price_total ? `Rp${digitGroup(row.price_total)}` : '-'
        },
        label: 'Total Tagihan',
        align: 'left',
        sortable: true,
        classes: 'text-no-wrap'
      },
      {
        name: 'created_at',
        field: (row) =>
          commonDate({
            date: row.created_at,
            useDayName: true
          }),
        label: 'Tanggal Invoice Dibuat',
        align: 'left',
        sortable: true,
        classes: 'text-no-wrap'
      },
      {
        name: 'status',
        field: (row) => {
          const type = row.do.length === 1 ? 'Satuan' : 'Gabungan'
          return `<div class="custom-badge custom-badge-green">${type}</div>`
        },
        label: 'Jenis Invoice',
        align: 'left',
        sortable: true
      },
      {
        name: 'do_no',
        field: (row) => {
          if (row.do.length) {
            return (
              `<div>${row.do[0].do_no}</div>` +
              (row.do.length > 1
                ? `<div class="custom-toggle">
                      <label>
                        <input type="checkbox"/>
                        <div class="custom-toggle--text">
                          <small class="text-primary text-bold">
                            + ${row.do.length - 1} Lainnya
                          </small>
                        </div>

                        <div class="custom-toggle--content">
                          ${row.do
                            .filter((_item, index) => index !== 0)
                            .map((item) => `<div>${item.do_no}</div>`)}
                        </div>
                      </label>
                    </div>`
                : '')
            )
          } else {
            return '-'
          }
        },
        label: 'No. Delivery Order',
        align: 'left',
        sortable: true
      }
    ]
  },

  invoiceForm: {
    columns: [
      {
        name: 'do_no',
        field: 'do_no',
        label: 'No. Delivery Order',
        align: 'left',
        sortable: true,
        classes: 'text-bold'
      },
      {
        name: 'po_no',
        field: 'po_no',
        label: 'No. Purchase Order',
        align: 'left',
        sortable: true,
        classes: 'text-bold'
      },
      {
        name: 'return_date',
        field: (row) => {
          const date = row.return_letter_at
          return commonDate({
            date,
            useDayName: true
          })
        },
        label: 'Tanggal SJ Balik',
        align: 'left',
        sortable: true,
        classes: 'text-no-wrap'
      },
      {
        name: 'total_price',
        field: (row) => {
          return `Rp${digitGroup(row.total)}`
        },
        label: 'Total Tagihan',
        align: 'left',
        sortable: true
      },
      {
        name: 'qty_update',
        field: (row) =>
          row.qty_update
            ? '<span class="text-negative">Ada</span>'
            : '<span class="text-primary">Tidak Ada</span>',
        label: 'Perubahan Kuantitas',
        align: 'left',
        sortable: true
      },
      {
        name: 'travel_permit',
        field: 'travel_permit',
        label: 'Surat Jalan',
        align: 'left',
        sortable: false
      },
      {
        name: 'return_letter',
        field: 'return_letter',
        label: 'SJ Balik',
        align: 'left',
        sortable: false
      }
    ]
  },

  doList: {
    tabs: {
      all: [
        {
          name: 'do_no',
          label: 'No. Delivery Order',
          align: 'left',
          field: (row) => {
            const listGoodsHandOverStatus = {
              FRANCO: {
                label: 'Franco',
                color: 'blue'
              },
              LOCO: {
                label: 'Loco',
                color: 'purple'
              },
              LOCO_CUSTOMER: {
                label: 'Loco Customer',
                color: 'green'
              }
            }
            const badgeClass = listGoodsHandOverStatus[row?.goods_handover_status]?.color || 'green'
            return `
              <div>
                <strong
                  router-push="${encodeURIComponent(
                    JSON.stringify({
                      name: 'do-detail',
                      params: {
                        id: row.id,
                        name: row.do_no
                      }
                    })
                  )}"
                >${row.do_no}</strong>
                ${
                  row.alert && !!row.alert
                    ? ` <img
                    src="${require('src/assets/images/icons/16x16-yellow-alert.svg')}"
                    class="color-blue"
                    alt="icon"
                  >`
                    : ''
                }
              </div>
              ${
                listGoodsHandOverStatus[row?.goods_handover_status]?.label &&
                `
                <div role="alert" class="custom-badge-square custom-badge-${badgeClass}">
                  ${listGoodsHandOverStatus[row?.goods_handover_status]?.label || ''}
                </div>`
              }
            `
          },
          sortable: true,
          rowClass: 'text-no-wrap'
        },
        {
          name: 'po_no',
          label: 'No. Purchase Order',
          align: 'left',
          field: (row) => {
            const companyName = `
              <div class="text-grey-7">
                ${row.supplier_name || ''}
              </div>`

            return `
              <div>
                <strong
                  router-push="${encodeURIComponent(
                    JSON.stringify({
                      name: 'po-detail',
                      params: {
                        id: row.po_id,
                        name: row.po_no
                      }
                    })
                  )}"
                >${row.po_no}</strong>
              </div>
              ${companyName}
            `
          },
          sortable: true,
          rowClass: 'text-no-wrap'
        },
        {
          name: 'so_no',
          label: 'No. Sales Order',
          align: 'left',
          field: (row) => {
            return `
              <div>
                <strong
                  router-push="${encodeURIComponent(
                    JSON.stringify({
                      name: 'so-detail',
                      params: {
                        id: row.so_id,
                        name: row.so_no
                      }
                    })
                  )}"
                >${row.so_no}</strong>
              </div>
            `
          },
          sortable: true,
          rowClass: 'text-no-wrap'
        },
        {
          name: 'customer_name',
          label: 'Customer',
          align: 'left',
          field: (row) => {
            return `
            <div class="text-weight-bold">${row.customer_name}</div>
            ${
              row.company_name
                ? `<div>${row.company_type || ''} ${row.company_name}</div>`
                : ''
            }
            `
          },
          rowClass: 'td-width-medium text-capitalize'
        },
        {
          label: 'Jenis Pembayaran',
          name: 'bnpl_name',
          field: (row) => {
            const paymentType =
              {
                'MODAL RAKYAT': 'Modal Rakyat',
                'JM TEMPO': 'JM Tempo',
                'JM PAYLATER': 'JM Paylater',
                PAPER: 'Paper.id',
                KOINWORKS: 'Koinworks',
                CREDILINQ: 'Credilinq.ai'
              }[row.bnpl_name] || 'Tunai'

            const image = row.bnpl_name
              ? row.image_payment
              : require('src/assets/images/icons/24x24-tunai-circle.png')

            return `<div class="flex no-wrap items-center gap-2">
              <img
                src="${image}"
                alt="${row.payment_type}"
                class="payment-type-img"
              >
              <div class="flex column text-no-wrap">
                <strong>${paymentType}</strong>
                <span class="text-grey-7">
                  ${row.bnpl_name ? row.top_day + ' Hari' : 'Transfer Manual'}
                </span>
              </div>
            </div>`
          },
          align: 'left'
        },
        {
          name: 'district',
          label: 'Kecamatan Tujuan',
          align: 'left',
          field: (row) => {
            return `
            <div class="text-weight-bold">${row.district}</div>
            `
          },
          rowClass: 'td-width-small text-capitalize'
        },
        {
          name: 'product',
          label: 'Jumlah Barang',
          align: 'left',
          field: (row) => {
            const { product } = row
            const hasItem = product.length > 0
            const qty = `+${product.length - 1} Lainnya`
            return hasItem
              ? `
                <div class="column text-left">
                  <p class="q-mb-xs">${product[0]?.product_name}</p>
                  <p
                    class="no-margin ${
                      product.length <= 1 && 'hidden'
                    }" style="font-size: 10px"
                  >
                    ${qty}
                  </p>
                </div>
              `
              : '-'
          },
          rowClass: 'td-width-small'
        },
        {
          name: 'shipping_at',
          label: 'Estimasi Diterima',
          field: (row) => {
            return row.shipping_at && !!row.shipping_at
              ? `<div class="flex column">
                  <span>
                    ${commonDate({
                      date: row.shipping_at,
                      useDayName: true
                    })}
                  </span>
                </div>`
              : '-'
          },
          align: 'left',
          rowClass: 'text-no-wrap'
        },
        {
          name: 'sending_at',
          label: 'Tanggal Pengiriman',
          align: 'left',
          field: (row) =>
            row.sending_at && !!row.sending_at
              ? `<div class="flex column">
                  <span>
                    ${commonDate({
                      date: row.sending_at,
                      useDayName: true
                    })}
                  </span>
                  <span class="text-grey-7">
                    ${dateTime(row.sending_at)}
                  </span>
                </div>`
              : '-',
          rowClass: 'text-no-wrap'
        },
        {
          name: 'received_at',
          label: 'Tanggal Tiba',
          align: 'left',
          field: (row) =>
            row.received_at && !!row.received_at
              ? `<div class="flex column">
                  <span>
                    ${commonDate({
                      date: row.received_at,
                      useDayName: true
                    })}
                  </span>
                  <span class="text-grey-7">
                    ${dateTime(row.received_at)}
                  </span>
                </div>`
              : '-',
          rowClass: 'text-no-wrap'
        },
        {
          name: 'return_letter_at',
          label: 'Tanggal SJ Balik',
          align: 'left',
          field: (row) =>
            row.return_letter_at && !!row.return_letter_at
              ? `<div class="flex column">
                  <span>
                    ${commonDate({
                      date: row.return_letter_at,
                      useDayName: true
                    })}
                  </span>
                  <span class="text-grey-7">
                    ${dateTime(row.return_letter_at)}
                  </span>
                </div>`
              : '-',
          rowClass: 'text-no-wrap'
        },
        {
          name: 'status',
          label: 'Status',
          align: 'left',
          field: 'status',
          format: (val) => {
            const status = wording[lang].doStatus[val]
            if (val && status) {
              const listStatus = {
                PROCESSED: 'yellow',
                SCHEDULED: 'blue',
                DRIVER_ASSIGNED: 'purple',
                ON_DELIVERY: 'yellow',
                SENT: 'blue',
                RETURN_LETTER: 'purple',
                FINISHED: 'green',
                CANCELED: 'red'
              }
              const badgeClass = listStatus[val] || 'green'

              return `
                <div role="alert" class="custom-badge custom-badge-${badgeClass}">
                  ${status}
                </div>
              `
            }

            return '-'
          }
        },
        {
          name: 'updated_at',
          label: 'Tanggal Dibatalkan',
          field: (row) => {
            return row.updated_at && !!row.updated_at
              ? `<div class="flex column">
                  <span>
                    ${commonDate({
                      date: row.updated_at,
                      useDayName: true
                    })}
                  </span>
                </div>`
              : '-'
          },
          align: 'left',
          rowClass: 'text-no-wrap'
        }
      ]
    }
  }
}

export default tables
